import { phoneFormatter } from "@medflyt/webapp-react/src/shared/utils/phone-formatter";

const { isValidNumber, formatE164, formatNational } = phoneFormatter;

export default { isValidNumber, formatE164, formatNational };
